import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import LocalStorage from '@app/helpers/LocalStorage';
import SessionStorage from '@app/helpers/SessionStorage';
import { Observable } from 'rxjs';


@Injectable({ providedIn: 'root' })
export class HwAuthInterceptorService implements HttpInterceptor {

  constructor(
    protected router: Router,
  ) { }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let cloned;
    let token: string;

    if (req.url.startsWith('/assets')) {
      return next.handle(req);
    }
    if (LocalStorage.IsTabletMode) {
      if (LocalStorage.OperationMode == 'VIP') {
        if (req.url.includes('CreateTabletToken') || req.url.includes('GetTableGuestStayUuid') || req.url.includes('CreateTabletToken')
          || req.url.includes('tablet')

        ) {
          token = ""
        } else {
          token = SessionStorage.GuestData?.Token;
        }
      } else { // csoportos üzemmód 
        if (req.url.includes('CreateTabletToken') || req.url.includes('tablet')) {
          token = ""
        } else {
          token = LocalStorage.TabletToken
        }

      }
    } else { // normál üzemmód
      if (req.url.includes('CreateGuestToken')) {
        token = ""
      } else {
        token = SessionStorage.GuestData?.Token;
      }

    }

    if (token == "") {
      cloned = req.clone({
        setHeaders: {
        }
      });
      return next.handle(cloned);
    } else {
      cloned = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
      return next.handle(cloned);
    }

  }

}
